import React from 'react';
import { NoticeProps } from 'react-select/src/components/Menu';

import { LoadingIndicator } from '../../loading-indicator';
import { Option } from '../option.model';

type LoadingMessageProps = { loadingMessage?: React.ReactNode } & NoticeProps<
  Option,
  true
>;

export const LoadingMessage = ({
  loadingMessage,
  children,
  innerProps,
}: LoadingMessageProps) => (
  <div className="px-6 py-4 space-y-2" {...innerProps}>
    <LoadingIndicator showMessage={false} />
    <div className="text-center">{loadingMessage ?? children}</div>
  </div>
);
